export default "__VITE_PUBLIC_ASSET__0b9dc1ad__"